export default __webpack_public_path__ + "static/media/proposal-side-image-two.0f31062f.png";